module.exports = __webpack_public_path__ + "static/media/icon-padlock.808c04a7.svg";